export default [
  { path: '/dashboard', name: 'dashboard', icon: null },
  { path: '/advance-request', name: 'advance request', icon: null },
  { path: '/customers', name: 'customers', icon: null },
  { path: '/advances', name: 'advances', icon: null },
  { path: '/banking', name: 'banking', icon: null },
]
